import type { RefObject } from 'react';

import type {
  AccessGrant,
  AccessPrincipal,
  AccessPrincipalSearchResult,
  AccessRole,
} from '../types/AccessControl';

export function getPrincipalKey(principal: AccessPrincipal): string {
  return `${principal.type}:${principal.id}`;
}

export function createGrantFromSearchResult(
  result: AccessPrincipalSearchResult,
  role: AccessRole,
): AccessGrant {
  return {
    principal: result.principal,
    role,
    source: 'direct',
  };
}

/** True when the event should dismiss a portaled menu in the Add People composite field. */
export function isOutsideCompositeDismissRoot(
  event: Event,
  root: HTMLElement | null | undefined,
  pairedRoots: ReadonlyArray<RefObject<HTMLElement | null>>,
): boolean {
  const target = event.target;
  if (!(target instanceof Node)) {
    return true;
  }
  if (root?.contains(target)) {
    return false;
  }
  for (const ref of pairedRoots) {
    if (ref.current?.contains(target)) {
      return false;
    }
  }
  return true;
}
